<template>
  <div class="mb-16">
    <div class="flex flex-col md:flex-row gap-12 items-start mb-8">
      <!-- Image container -->
      <div class="w-full md:w-1/2">
        <img
          :src="require('../../assets/images/team/' + member.image)"
          :alt="`${member.name}`"
          class="w-full h-auto object-cover"
        />
      </div>
      
      <!-- Text content -->
      <div class="w-full md:w-1/2 space-y-4 hyphens-auto">
        <div class="space-y-1 mt-4">
          <h1 class="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 text-hyphen">
            {{ member.name }}
          </h1>
          <h2 v-if="member.nickname" class="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 text-hyphen">
            "{{ member.nickname }}"
          </h2>
        </div>
        
        <h3 class="text-base font-sans italic text-gray-800 whitespace-normal">
          {{ member.title }}
        </h3>
        
        <p class="text-gray-700 leading-relaxed max-w-lg">
          {{ member.bio }}
        </p>
        
        <!-- Instagram link -->
        <div v-if="member.instagram" class="mt-6">
          <a 
            :href="`https://instagram.com/${member.instagram}`"
            target="_blank"
            rel="noopener noreferrer"
            class="text-gray-900 italic underline uppercase"
          >
            Instagram
          </a>
        </div>
      </div>
    </div>
    
    <!-- Divider - only show if not last -->
    <hr v-if="!isLast" class="mt-12 border-t border-gray-200">
  </div>
</template>

<script>
export default {
  name: 'TeamMember',
  props: {
    member: {
      type: Object,
      required: true,
      validator(value) {
        return [
          'name',
          'title',
          'bio',
          'image'
        ].every(prop => prop in value)
      }
    },
    isLast: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
  .text-hyphen {
    -webkit-hyphens: auto;
    -ms-hyphens: auto;
    hyphens: auto;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
</style>